/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Coins: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M17 16.0001C14.049 16.0001 11.597 15.3611 10 14.2881C10 15.0341 10 15.5261 10 16.0001C10 17.6571 13.134 19.0001 17 19.0001C20.866 19.0001 24 17.6571 24 16.0001C24 15.5261 24 15.0341 24 14.2881C22.403 15.3611 19.951 16.0001 17 16.0001Z'
      fill='currentColor'
    />
    <path
      d='M17 21.0001C14.049 21.0001 11.597 20.3611 10 19.2881C10 20.0341 10 20.5261 10 21.0001C10 22.6571 13.134 24.0001 17 24.0001C20.866 24.0001 24 22.6571 24 21.0001C24 20.5261 24 20.0341 24 19.2881C22.403 20.3611 19.951 21.0001 17 21.0001Z'
      fill='currentColor'
    />
    <path d='M17 14C20.866 14 24 12.6569 24 11C24 9.34315 20.866 8 17 8C13.134 8 10 9.34315 10 11C10 12.6569 13.134 14 17 14Z' fill='currentColor' />
    <path d='M7 6C10.866 6 14 4.65685 14 3C14 1.34315 10.866 0 7 0C3.13401 0 0 1.34315 0 3C0 4.65685 3.13401 6 7 6Z' fill='currentColor' />
    <path
      d='M8 17.9731C7.673 17.9891 7.341 18.0001 7 18.0001C4.049 18.0001 1.597 17.3611 0 16.2881C0 17.0341 0 17.5261 0 18.0001C0 19.6571 3.134 21.0001 7 21.0001C7.34 21.0001 7.673 20.9861 8 20.9661V17.9731Z'
      fill='currentColor'
    />
    <path
      d='M8 12.9731C7.673 12.9891 7.341 13.0001 7 13.0001C4.049 13.0001 1.597 12.3611 0 11.2881C0 12.0341 0 12.5261 0 13.0001C0 14.6571 3.134 16.0001 7 16.0001C7.34 16.0001 7.673 15.9861 8 15.9661V12.9731Z'
      fill='currentColor'
    />
    <path
      d='M9.92 7.76609C9.018 7.91609 8.042 8.00009 7 8.00009C4.049 8.00009 1.597 7.36109 0 6.28809C0 7.03409 0 7.52609 0 8.00009C0 9.65709 3.134 11.0001 7 11.0001C7.341 11.0001 7.674 10.9861 8.003 10.9661C8.015 9.70309 8.71 8.60609 9.92 7.76609Z'
      fill='currentColor'
    />
  </React.Fragment>
)
